import {EnvironmentInterface} from '@app/app/shared/interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  jsonrpcVersion: '2.0',
  apiUrl: 'https://maestropro.vortex-intl.com/api/v1',
  whitelistedDomains: ['maestropro.vortex-intl.com'],
  refreshTokenUrl: '/access-tokens/refresh',
  weather: {
    appid: '7e33ba9a817138e842faf18b16982d76',
    url: 'https://api.openweathermap.org/data/2.5/weather',
    iconsUrl: 'https://openweathermap.org/img/w/'
  },
  google: {
    maps: {
      key: 'AIzaSyC0-I9LNBu2PXbEE4ti1CRnbGmbZMbpXwI'
    }
  },
  aws: {
    poolId: 'us-east-2:54886646-8359-4199-a89a-594208436a00',
    host: 'a305k7pep4hpxr-ats.iot.us-east-2.amazonaws.com',
    region: 'us-east-2'
  },
  version: '1.0.101'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts